export interface CatalogPage {
  number: number;
  alt: string;
}

export interface Catalog {
  id: string;
  assetRoot: string;
  title: string;
  titleEn: string;
  eyebrow: string;
  websiteUrl: string;
  width: number;
  height: number;
  pages: readonly CatalogPage[];
}

const pageAlts = [
  "蓝宇机械 2026 企业画册封面",
  "蓝宇机械公司联系方式、网站与地址",
  "蓝宇机械厂区与公司大楼",
  "蓝宇机械中英文公司简介",
  "蓝宇机械企业荣誉与代表客户",
  "蓝宇机械代表客户名录",
  "双室侧井熔炼炉设备实景",
  "双室侧井熔炼炉功能与技术参数",
  "矩形熔炼炉和保温炉设备实景",
  "矩形熔炼炉和保温炉功能与技术参数",
  "圆形熔炼炉和保温炉设备实景",
  "圆形熔炼炉和保温炉功能与技术参数",
  "倾动式熔炼炉和保温炉设备实景",
  "倾动式熔炼炉和保温炉功能与技术参数",
  "高效节能蓄热式燃烧系统",
  "低氮弥散式燃烧系统",
  "废铝高效预热和脱漆窑设备实景",
  "废铝高效预热和脱漆窑功能与技术参数",
  "内导式液压半连续铸造机设备实景",
  "内导式液压半连续铸造机功能与技术参数",
  "合金锭铸造机设备实景",
  "合金锭铸造机功能与技术参数",
  "铝垛机器人设备实景",
  "铝垛机器人功能与技术参数",
  "铝灰处理回转炉",
  "铝灰冷却设备冷灰桶",
  "脉冲式布袋除尘器",
  "蓝宇机械其他设备一览",
] as const;

const companyCatalog2026: Catalog = {
  id: "lanyu-machinery-2026",
  assetRoot: "catalog/2026/pages",
  title: "蓝宇机械 2026 企业画册",
  titleEn: "Lanyu Machinery 2026 Company Catalog",
  eyebrow: "2026 COMPANY CATALOG",
  websiteUrl: "https://fslyjx.net/",
  width: 2880,
  height: 2159,
  pages: pageAlts.map((alt, index) => ({ number: index + 1, alt })),
};

export const catalogs: readonly Catalog[] = [companyCatalog2026];
export const defaultCatalog = companyCatalog2026;

export function selectCatalog(
  id: string | null | undefined,
  availableCatalogs: readonly Catalog[] = catalogs,
): Catalog {
  const fallback = availableCatalogs[0];
  if (!fallback) throw new Error("At least one catalog must be configured.");
  return availableCatalogs.find((catalog) => catalog.id === id) ?? fallback;
}

export interface PageAssets {
  small: string;
  large: string;
  high: string;
  srcset: string;
}

export function pageAssets(
  catalog: Catalog,
  page: number,
  base = "/",
): PageAssets {
  const paddedPage = String(page).padStart(2, "0");
  const root = `${base}${catalog.assetRoot}/page-${paddedPage}`;
  const small = `${root}-960.jpg`;
  const large = `${root}-2880.jpg`;
  const high = `${root}-5760.jpg`;

  return {
    small,
    large,
    high,
    srcset: `${small} 960w, ${large} 2880w`,
  };
}
